import { SVGProps } from 'react';

export const Other = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.71429 6.10714C4.71429 6.58114 4.33029 6.96429 3.85714 6.96429C3.38314 6.96429 3 6.58114 3 6.10714C3 5.63357 3.38314 5.25 3.85714 5.25C4.33029 5.25 4.71429 5.63357 4.71429 6.10714Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.85735 6.10714C6.85735 6.58114 6.47335 6.96429 6.00021 6.96429C5.52621 6.96429 5.14307 6.58114 5.14307 6.10714C5.14307 5.63357 5.52621 5.25 6.00021 5.25C6.47335 5.25 6.85735 5.63357 6.85735 6.10714Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99993 6.10714C8.99993 6.58114 8.61593 6.96429 8.14279 6.96429C7.66879 6.96429 7.28564 6.58114 7.28564 6.10714C7.28564 5.63357 7.66879 5.25 8.14279 5.25C8.61593 5.25 8.99993 5.63357 8.99993 6.10714Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00005 1.59999C3.574 1.59999 1.60005 3.57394 1.60005 5.99999C1.60005 8.42604 3.574 10.4 6.00005 10.4C8.4261 10.4 10.4001 8.42604 10.4001 5.99999C10.4001 3.57394 8.4261 1.59999 6.00005 1.59999ZM6 11.5C2.9673 11.5 0.5 9.0327 0.5 6C0.5 2.9673 2.9673 0.5 6 0.5C9.0327 0.5 11.5 2.9673 11.5 6C11.5 9.0327 9.0327 11.5 6 11.5Z"
      fill="currentColor"
    />
  </svg>
);
